// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-block__pre-heading[data-v-5d1eeefb]{justify-content:center;text-align:center;font-family:Flame!important}.custom-color[data-v-5d1eeefb]{color:#502314}.subtitle-1[data-v-5d1eeefb]{font-weight:700;color:#fff}", ""]);
// Exports
module.exports = exports;
